import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as userAction from "../../../redux/actions/userAction";
import UserList from "../component/users/userList";
import { useNavigate } from "react-router-dom";
import * as adminAction from "../../../redux/actions/adminCommonAction";

import {
  ACCESS_DENIED,
  ADD_ADMIN_GROUP,
  ADD_ADMIN_USER,
  ADMIN_USER,
  VIEW_ADMIN_USER,
} from "../../../constant/routeContant";
import { API_STATUS, ORG_ID, PAGE_SIZE } from "../../../constant/constant";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { PRODUCT_ID } from "../../../constant/storm-water/constant";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../../../library/common/Loader";
import { getPreviousRoute } from "../../../utils/routeTracker";

const UsersListContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userListData = useSelector((state) => state.userlistData);
  const [sendEmail, setSendEmail] = useState(false);
  const [accessUserId, setAccessUserId] = useState([]);
  const [clickVerifyBtn, setClickVerifyBtn] = useState(false);
  const [clickUserToNoUserBtn, setClickUserToNoUserBtn] = useState(false);
  const [shouldRestoreState, setShouldRestoreState] = useState(false);

  const sendBulkEmailVerificationData = useSelector(
    (state) => state.sendBulkEmailVerification,
  );
  const sendBulkEmailVerificationDataIsLoading = useSelector(
    (state) => state.sendBulkEmailVerification?.isLoading,
  );
  const convertToNoPrivilegeUserData = useSelector(
    (state) => state.convertToNoPrivilegeUser,
  );
  const NavigateSingleUserMethode = () => {
    navigate(ADD_ADMIN_USER);
  };
  const NavigateUserGroupMethode = () => {
    navigate(ADD_ADMIN_GROUP);
  };

  const getuserLists = (data) => {
    if (data?.isSendMail) {
      setSendEmail(true);
    } else {
      setSendEmail(false);
    }
    dispatch(userAction.getUserList(data));
    dispatch(userAction.getUserListFilterObj(data));
  };

  const companies = useSelector(
    (state) => state.getDropdownDataKeyValue?.data?.companies,
  );

  const jobTitles = useSelector(
    (state) => state.getDropdownDataKeyValue?.data?.jobTitles,
  );

  const division = useSelector(
    (state) => state.getDropdownDataKeyValue?.data?.divisons,
  );

  const deleteUserListData = useSelector((state) => state.deleteUserListData);

  const deleteLists = (userId) => {
    dispatch(userAction.deleteList(userId));
  };

  const getDropdownDataKeyValueData = {
    orgId: ORG_ID(),
    flags: "1,6,12",
    productId: PRODUCT_ID(),
  };
  useEffect(() => {
    dispatch(adminAction.getDropdownDataKeyValue(getDropdownDataKeyValueData));
  }, []);

  useEffect(() => {
    const previousRoute = getPreviousRoute();
    const preserveRoutes = [ADMIN_USER, VIEW_ADMIN_USER, ADD_ADMIN_USER];
    const isFromPreserveRoute =
      previousRoute &&
      preserveRoutes.some((r) => previousRoute.startsWith(r)) &&
      sessionStorage.getItem("userListPreserveState") === "true";
    sessionStorage.removeItem("userListPreserveState");

    const data = {
      page: 1,
      pageSize: PAGE_SIZE,
      search: "",
      orgId: ORG_ID(),
      IsProcoreUsers: false,
      divisionId: 0,
      designation: "",
      isSendMail: false,
      isEmailVerified: "",
    };

    if (isFromPreserveRoute && userListData?.filterObj) {
      setShouldRestoreState(true);
      getuserLists(userListData.filterObj);
    } else {
      setShouldRestoreState(false);
      getuserLists(data);
    }
    dispatch(userAction.ClearSendEmailVerification());
    dispatch(userAction.ClearSendBulkEmailVerification());
    setAccessUserId([]);
  }, []);

  useEffect(() => {
    if (deleteUserListData.status === "SUCCESS") {
      if (userListData?.filterObj) {
        getuserLists(userListData.filterObj);
      } else {
        const data = {
          page: 1,
          pageSize: PAGE_SIZE,
          search: "",
          isSendMail: false,
          isEmailVerified: "",
          IsProcoreUsers: false,
          divisionId: 0,
          designation: "",
        };
        getuserLists(data);
      }
    }
  }, [deleteUserListData]);

  useEffect(() => {
    if (userListData?.status === API_STATUS.SUCCESS && sendEmail) {
      toast("Users has been sent to registered email ID");
    }
  }, [userListData]);

  useEffect(() => {
    if (
      convertToNoPrivilegeUserData &&
      convertToNoPrivilegeUserData?.status === API_STATUS.SUCCESS &&
      clickUserToNoUserBtn
    ) {
      toast("The user has been changed to a non-privileged user.");

      setTimeout(() => {
        const data = {
          page: 1,
          pageSize: PAGE_SIZE,
          search: "",
          orgId: parseInt(ORG_ID()),
          IsProcoreUsers: false,
          divisionId: 0,
          designation: "",
          isSendMail: false,
          isEmailVerified: "",
        };
        getuserLists(data);
      }, 3000); // Wait 3 seconds before refreshing the list

      setClickUserToNoUserBtn(false);
    }
  }, [convertToNoPrivilegeUserData]);

  useEffect(() => {
    if (sendBulkEmailVerificationData?.status === "SUCCESS" && clickVerifyBtn) {
      setAccessUserId([]);
      setClickVerifyBtn(false);
      toast("Verification email sent successfully.");
      setTimeout(() => {
        window.location.reload();
      }, 3800);
    }
  }, [sendBulkEmailVerificationData]);

  const sendBulkEmailVarifation = (payload) => {
    dispatch(userAction.postSendBulkEmailVerification(payload));
  };

  const handleToNonPreUserOnClick = (payload) => {
    dispatch(userAction.postConvertToNoPrivilegeUser(payload));
  };


  return (
    <>
      {sendBulkEmailVerificationDataIsLoading && <Loader />}
      {checkPrivileges([12, 64, 65, 66]) ? (
        <>
          <ToastContainer />
          <UserList
            loading={userListData.isLoading}
            userListData={userListData?.data}
            NavigateSingleUser={NavigateSingleUserMethode}
            NavigateUserGroup={NavigateUserGroupMethode}
            getuserLists={getuserLists}
            deleteList={deleteLists}
            companies={companies}
            jobTitles={jobTitles}
            division={division}
            isShowDowdownloadButton={true}
            sendBulkEmailVarifation={sendBulkEmailVarifation}
            setClickVerifyBtn={setClickVerifyBtn}
            setAccessUserId={setAccessUserId}
            accessUserId={accessUserId}
            handleToNonPreUserOnClick={handleToNonPreUserOnClick}
            setClickUserToNoUserBtn={setClickUserToNoUserBtn}
            userListDatas={userListData}
            shouldRestoreState={shouldRestoreState}
          />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
};

export default UsersListContainer;
